(() => {
  const ROWS_TO_SHOW = 5;

  /**
   * Compute an element's line-height as a number (px).
   */
  function getLineHeightPx(el) {
    const cs = window.getComputedStyle(el);
    const lh = cs.lineHeight;
    if (lh === "normal") {
      // Fallback: roughly 1.2 * font-size (not used here since you set a px line-height)
      const fs = parseFloat(cs.fontSize) || 16;
      return 1.2 * fs;
    }
    return parseFloat(lh);
  }

  /**
   * Clamp a description to N rows if it exceeds that count.
   * Returns an object with cleanup/expand behavior.
   */
  function makeClampController(container) {
    const desc = container.querySelector(
      ".details-product-content-description"
    );
    const btn = container.querySelector(".details-product-content-see-more");
    if (!desc) return null;

    const lineHeight = getLineHeightPx(desc);
    if (!lineHeight || !Number.isFinite(lineHeight)) return null;

    const clampHeight = lineHeight * ROWS_TO_SHOW;

    /**
     * Whether the description currently exceeds N rows.
     */
    function exceedsRows() {
      // Use scrollHeight to detect full content height
      // Subtract vertical paddings to reduce false positives
      const cs = window.getComputedStyle(desc);
      const padY =
        parseFloat(cs.paddingTop || 0) + parseFloat(cs.paddingBottom || 0);
      const contentHeight = desc.scrollHeight - padY;
      const rows = contentHeight / lineHeight;
      return rows > ROWS_TO_SHOW + 0.01; // small epsilon
    }

    /**
     * Apply clamping (truncate + fade).
     */
    function applyClamp() {
      if (!exceedsRows()) {
        // Not long enough: ensure it's fully visible and hide the button if present
        clearClamp();
        if (btn) btn.style.display = "none";
        return;
      }
      // Clamp
      desc.style.maxHeight = `${clampHeight}px`;
      desc.classList.add("is-clamped");
      if (btn) btn.style.display = ""; // ensure visible if needed
    }

    /**
     * Remove clamping (show full content, remove fade).
     */
    function clearClamp() {
      desc.style.maxHeight = "";
      desc.classList.remove("is-clamped");
    }

    /**
     * Public expand: show full content and remove the button.
     */
    function expandAndRemoveButton() {
      clearClamp();
      if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
    }

    return { applyClamp, clearClamp, expandAndRemoveButton, button: btn };
  }

  /**
   * Initialize all content blocks on the page.
   */
  function init() {
    const blocks = Array.from(
      document.querySelectorAll(".details-product-content")
    );
    const controllers = [];

    blocks.forEach((block) => {
      const ctrl = makeClampController(block);
      if (!ctrl) return;

      // Initial clamp
      ctrl.applyClamp();

      // Click handler: one-way expand and remove button
      if (ctrl.button) {
        ctrl.button.addEventListener(
          "click",
          () => {
            ctrl.expandAndRemoveButton();
          },
          { once: true }
        ); // ensure one-time
      }

      controllers.push(ctrl);
    });

    // Re-evaluate on resize (debounced)
    let resizeTimer = null;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        controllers.forEach((ctrl) => ctrl.applyClamp());
      }, 150);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
